import React, { useMemo, useState } from 'react'
import classNames from 'classnames'
import Back from '../../features/back/Back'
import { gameRating, gamesList } from '../../../constants/copyright'
import { safeHTML } from '../../../utils/safeHTML'
import { useContent } from '../../../redux/reducer/content'
import { useRequests } from '../../../redux/reducer/requests'
import useStateControls from '../../../hooks/useStateControls'
import { useExtraProfile } from '../../../hooks/useExtraProfile'
import AppLoader from '../../features/appLoader/AppLoader'
import { useTranslation } from '../../../translations'
import Toggle from '../../baseComponents/gui/toggle/Toggle'
import { RatingItems } from '../../features/rating'
import { GAMES } from '../../../constants/shared/states/names'

const [
  {
    box,
    box: { toggle: toggleData },
  },
  { list },
] = [gameRating, gamesList]

const GameRating = React.forwardRef(function (_, ref) {
  const { t } = useTranslation()
  const {
    authData: { isWeb },
  } = useRequests()
  const {
    gameRating: gameRatingData,
    gameRatingOld: gameRatingOldData,
    currentGameSeason,
    activeGameRatingName,
  } = useContent()

  const { setState } = useStateControls()

  const [toggle, setToggle] = useState('current')

  const setters = {
    current: () => setToggle('current'),
    old: () => setToggle('old'),
  }

  const ratingInfo = {
    activeRatings: {
      user: gameRatingData[`user${activeGameRatingName}`] ?? {},
      rating: gameRatingData?.[activeGameRatingName] ?? [],
    },
  }

  const oldRatingInfo = {
    activeRatings: {
      user:
        // todo: здесь бек не может отдать результат предыдущего сезона,
        // для конкретного игрока, поэтому приходится искать по uid
        gameRatingOldData?.[activeGameRatingName]?.find(
          (player) => player.uid === gameRatingOldData[`user${activeGameRatingName}`]?.uid,
        ) ?? {},
      rating: gameRatingOldData?.[activeGameRatingName] ?? [],
    },
  }

  const title = Object.values(list)?.find(({ apiName }) => apiName === activeGameRatingName)?.title

  const isPendingProfile = useExtraProfile()

  return (
    <section
      className={classNames('game-rating', { app: !isWeb })}
      ref={ref}
    >
      <div className={'game-rating__header'}>
        <Back onClick={() => setState(GAMES)} />
        <h2 className={'game-rating__title'}>{safeHTML(t(title))}</h2>
      </div>
      <div className={'game-rating__content'}>
        {/*  <GamesRatingBox
          {...box}
            date={t(box.date)}
            text={t(box.text)}
            button={{
              ...box.button,
              text: t(box.button.text)
            }}
          isGame={false}
          seasonDates={currentGameSeason}
        /> */}
        <Toggle
          className={toggleData?.className || ''}
          list={toggleData?.list || []}
          funcs={setters}
        />

        <div className={'game-rating__items'}>
          <RatingItems
            ratingInfo={{ current: ratingInfo, old: oldRatingInfo }[toggle]}
            isPending={isPendingProfile}
          />
        </div>
      </div>

      {isPendingProfile && <AppLoader />}
    </section>
  )
})
export default GameRating
